import script from "./AdminAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAuth.vue?vue&type=script&setup=true&lang=js"

import "./AdminAuth.vue?vue&type=style&index=0&id=2bd9109d&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd9109d"]])

export default __exports__